import { Typography, Row, Col } from 'antd'
import './index.scss'

const { Title, Paragraph } = Typography

const features = [
    {
        filename: "features-1.png",
        title: "Science-Backed Insights",
        description: "The purpose survey and personalized recommendations are grounded in psychology and developed by experts."
    },
    {
        filename: "features-2.png",
        title: "Personalized Learning",
        description: "Your journey is tailored to your goals, passions, and values, providing a unique path just for you."
    },
    {
        filename: "features-3.png",
        title: "Engaging and Rewarding",
        description: "Moodra offers a gamified journey, so each step you take is celebrated, keeping you motivated as you progress"
    },
    {
        filename: "features-4.png",
        title: "Supportive Community",
        description: "Join a positive, purpose-driven community to share your growth journey, exchange ideas, and stay inspired."
    }
]

export default function FeaturesSection() {
    return (
        <section className="features-container">
            <div className='section-content-heading'>
                <span className="section-tag">CORE FEATURES</span>
                <Title className="section-title">
                    Why choose Moodra
                    <img
                        src="/images/vector.png"
                        alt="vector"
                        className="title-underline"
                        style={{
                            maxWidth: '60%',
                            left: '22%'
                        }}
                    />
                </Title>
            </div>

            <Row gutter={[32, 32]} className="features-grid">
                {features.map((feature, index) => (
                    <Col xs={24} sm={12} lg={6} key={index} style={{ display: 'flex' }}>
                        <div className="feature-card">
                            <div className="icon-wrapper">
                                <img src={`/images/${feature.filename}`} alt={feature.title} />
                            </div>
                            <Title level={3} className="card-title">
                                {feature.title}
                            </Title>
                            <Paragraph className="card-description">
                                {feature.description}
                            </Paragraph>
                        </div>
                    </Col>
                ))}
            </Row>
        </section>
    )
}

